const defaultTable = require("./default-table");

const getXAxisValue = (playerCards, total) => {
  const objName = playerCards
    .map(e => {
      if (
        e.rank.toLowerCase() === "j" ||
        e.rank.toLowerCase() === "q" ||
        e.rank.toLowerCase() === "k"
      )
        return 10;
      return e.rank;
    })
    .join("_");

  return playerCards.length == 2 && defaultTable.default[objName]
    ? objName
    : total;
};

const translateHint = hintCode => {
  const hintStrings = {
    S: "STAND",
    SP: "SPLIT",
    H: "HIT",
    D: "DOUBLE"
  };

  return hintStrings[hintCode] || "STAND";
};

const getCardCounterValue = (counterType, card) => {
  if (!card.showingFace) return 0;
  if (counterType == "hilo") {
    if (card.rank >= 2 && card.rank <= 6) {
      return 1;
    } else if (card.rank == 7 || card.rank == 8 || card.rank == 9) {
      return 0;
    } else {
      return -1;
    }
  } else {
    if (card.rank >= 2 && card.rank <= 7) {
      return 1;
    } else if (card.rank == 8 || card.rank == 9) {
      return 0;
    } else {
      return -1;
    }
  }
};

module.exports = { getXAxisValue, translateHint, getCardCounterValue };



// WEBPACK FOOTER //
// ./src/utils.js